import React, { useEffect } from "react";
import { useRoles } from "../../../application/roles/hooks/useRoles";
import "./style.css"
import Page from "../../ui/page";
import DynamicTable from "../../ui/table2";
import FloatingButton from "../../ui/floatButton";
import { ModalConfirm } from "../../ui/modal2";
import ToolbarComponent from "../../ui/section";

const RoleView = (props) => {
    const {
        columns,
        roles,
        customElements,
        goView,
        openRemove,
        setOpenRemove,
        handleRemove,
        goBack,
        goNew,
        getAll,
    } = useRoles(props);

    useEffect(() => {
        getAll();
    }, [getAll]);
    return <>
        <Page>
            <ToolbarComponent label="Roles de usuario" showBackButton={false} onBackClick={goBack}>
                <DynamicTable
                    headers={columns}
                    data={roles}
                    customElements={customElements}
                    fullPage={true}
                    showLabel={false}
                />
                <FloatingButton position="bottom-right" onClick={goNew}></FloatingButton>
                <ModalConfirm isOpen={openRemove} onClose={() => setOpenRemove(false)} onAccept={handleRemove} />
            </ToolbarComponent>
        </Page>
    </>
}

export default RoleView;